module.exports = __webpack_public_path__ + "img/manage.36eb313a.svg";